type FeatureFlags = 'WithLoginMagicLink' | 'WithSignUpMagicLink' | 'WithMultiUserOrganizations' | 'WithDeleteUser';

export const getFeatureFlags = (): Record<FeatureFlags, boolean> => ({
  WithLoginMagicLink: process.env.REACT_APP_ENABLE_MAGIC_LINK_LOGIN === 'true',
  WithSignUpMagicLink: process.env.REACT_APP_ENABLE_MAGIC_LINK_SIGNUP === 'true',
  WithMultiUserOrganizations: process.env.REACT_APP_ENABLE_MULTI_USER_ORGANIZATIONS === 'true',
  WithDeleteUser: process.env.REACT_APP_ENABLE_DELETE_USER === 'true',
});
